// window.eventDataJsonString = '{"id_1_0_0_0_0_0":[{"eventName":"mouseover","nodeId":"id_2_0_0_0_0","method":"show","methodParams":{"duration":1}},{"eventName":"mouseout","nodeId":"id_2_0_0_0_0","method":"hide","methodParams":[]}]}'


startListen()


function startListen() {
  ['click', 'mouseover', 'mouseout'].forEach((eventType) => {
    if(typeof document !== 'undefined'){
      document.addEventListener(eventType, (ev) => {
        var isInEditor = isInEditorFn()
        if(isInEditor){
          if(localStorage.getItem('enableEvents') !== 'true'){
            return
          }
        }

        if (!window.eventNet) {
          createEventNet()
        }

        var eventDomIds = getEventDomId(ev.target, window.eventNet)
        eventDomIds.forEach((eventDomId) => {
          if (window.eventNet[eventDomId]) {
            var methodDescriptions = window.eventNet[eventDomId][ev.type]
            if (methodDescriptions) {
              methodDescriptions.forEach((methodDescription) => {
                var triggerDom = document.querySelector('.' + methodDescription.nodeId)
                if (triggerDom) {

                  var matchedActionItem = actionListOfReanod.find((actionItem)=>{
                    return actionItem.id === methodDescription.method
                  })
                  if(matchedActionItem && matchedActionItem.fn){
                    matchedActionItem.fn.call(triggerDom, methodDescription.methodParams)
                  }

                }
              })
            }
          }


        })
      }, false)
    }

  })
}

function isInEditorFn(){
  return typeof mm !== 'undefined'
}

function createEventNet() {
  var net = {}
  var eventNodes = getEventNodes((()=>{
    var isInEditor = isInEditorFn()
    if(isInEditor){
      return {
        list: mm.store.state.hasList
      }
    }else{
      return {
        list: (()=>{
          var arr = []
          var eventDataJson = JSON.parse(window.eventDataJsonString)
          Object.keys(eventDataJson).forEach((nodeId)=>{
            arr.push({
              id: nodeId,
              data: {
                event: eventDataJson[nodeId]
              }
            })
          })
          return arr
        })()
      }
    }

  })())
  eventNodes.forEach((eventNode) => {
    eventNode.data.event.forEach((eventItem) => {

      if (!net[eventNode.id]) {
        net[eventNode.id] = {}
      }

      if (!net[eventNode.id][eventItem.eventName]) {
        net[eventNode.id][eventItem.eventName] = []
      }

      net[eventNode.id][eventItem.eventName].push({
        nodeId: eventItem.nodeId,
        method: eventItem.method,
        methodParams: eventItem.methodParams,
      })


    })
  })
  window.eventNet = net
  return net
}
self.createEventNet = createEventNet


function getEventNodes(node) {
  var res = []
  walkNode(node, (walkedNode) => {
    if (
      walkedNode.data &&
      walkedNode.data.event &&
      walkedNode.data.event.length
    ) {
      res.push(walkedNode)
    }
  })
  return res
}

function walkNode (node, callback, level) {
  if (typeof level === 'undefined') {
    level = 0
  }
  callback && callback(node, level)
  if (node.list) {
    level++
    node.list.forEach((subNode, subNodeIndex) => {
      subNode._index =
        (() => {
          if (typeof node._index === 'undefined') {
            node._index = '0'
          }
          return node._index
        })() +
        '_' +
        subNodeIndex
      walkNode(subNode, callback, level)
    })
  }
}




function bubbleAncestorDoms(dom, fn) {
  let isContinue = true
  while (isContinue) {
    var parentDom = dom.parentElement
    if (parentDom) {
      fn(parentDom)
      dom = parentDom
    } else {
      isContinue = false
    }
  }
}

function getDomClassId(dom) {
  var arr = []
  if (dom.classList) {
    dom.classList.forEach((className) => {
      arr.push(className)
    })
  }


  var id = arr.find((item) => {
    return item.match('id_')
  })
  return id
}

function getAncestorDomIds(dom) {
  var res = []

  var classIdOfDom = getDomClassId(dom)
  if (classIdOfDom) {
    res.push(classIdOfDom)
  }

  bubbleAncestorDoms(dom, (parentDom) => {
    var classIdOfParentDom = getDomClassId(parentDom)
    if (classIdOfParentDom) {
      res.push(classIdOfParentDom)
    }
  })
  return res
}

function getEventDomId(dom, eventNet) {
  var res = []
  var ids = getAncestorDomIds(dom)
  ids.forEach((id) => {
    if (eventNet[id]) {
      res.push(id)
    }
  })
  return res
}



self.actionListOfReanod = [
  {
    id: 'show',
    name: '显示',
    params: [
      {
        name: 'duration',
        displayName: '耗费时长',
        type: 'duration',
        initValue: 1
      }
    ],
    fn: function(params = {}){
      params.duration = params.duration || 1
      $(this).stop( true, true ).animate({opacity:1},params.duration * 1000,'linear',()=>{

      })
    }
  },
  {
    id: 'hide',
    name: '隐藏',
    params: [
      {
        name: 'duration',
        displayName: '耗费时长',
        type: 'duration',
        initValue: 1
      }
    ],
    fn: function(params = {}){
      params.duration = params.duration || 1
      $(this).stop( true, true ).animate({opacity:0},params.duration * 1000,'linear',()=>{

      })
    }
  },
  {
    id: 'move',
    name: '移动'
  },
  {
    id: 'filter',
    name: '过滤'
  }
]

